/**
 * On-Call Logs API Services
 */

import datacentral from '@/utils/axios/datacentral'
import { ResponseArray } from '@/types/shared'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'

import { OncallLogResponse } from '../types/response'

export const getOncallLogs = async (payload: DataGridPayload) => {
    const params = new URLSearchParams({
        page: String(payload?.page || 1),
        page_size: String(payload?.page_size || 10),
    })
    if (payload?.q) params.append('q', payload.q)
    if (payload?.filters) params.append('filters', payload.filters)

    const response = await datacentral.get<ResponseArray<OncallLogResponse>>(
        `/oncall/logs?${params.toString()}`
    )

    // Transform result to results for GokuDataGrid compatibility
    const data = response.data as any
    if (data.result && !data.results) {
        data.results = data.result
    }
    return data
}

export const getRecentOncallLogs = async (limit: number = 10) => {
    const response = await datacentral.get<ResponseArray<OncallLogResponse>>(
        `/oncall/logs/recent?limit=${limit}`
    )
    return response.data
}

export const getLogsBySchedule = async (scheduleId: number) => {
    const response = await datacentral.get<ResponseArray<OncallLogResponse>>(
        `/oncall/logs/schedule/${scheduleId}`
    )
    return response.data
}

export const getLogsByAssignment = async (assignmentId: number) => {
    const response = await datacentral.get<ResponseArray<OncallLogResponse>>(
        `/oncall/logs/assignment/${assignmentId}`
    )
    return response.data
}
